import { gql } from "@apollo/client";

export const DISSOLVE_CONSOLIDATION_TASK = gql`
  mutation DissolveConsolidationTask($taskId: String!) {
    dissolveConsolidationTask(taskId: $taskId) {
      success
      dissolvedBagCount
      releasedOrderCount
      message
    }
  }
`;

export interface DissolveConsolidationTaskVariables {
  taskId: string;
}

export interface DissolveConsolidationTaskResponse {
  dissolveConsolidationTask: {
    success: boolean;
    dissolvedBagCount: number;
    releasedOrderCount: number;
    message?: string;
  };
} 